import { HTMLStoreInformation } from './constants'

export const storeInformationGetMapEl = () =>
  document.querySelector<HTMLElement>(`#${HTMLStoreInformation}`)
